interface FeatureFlags {
  NEW_UI: boolean
  // Add more feature flags here as needed
}

// Debug logging
console.debug('Feature flags debug:', {
  'NEW_UI env var': process.env.NEW_UI,
  'env var type': typeof process.env.NEW_UI,
  'comparison result': process.env.NEW_UI === 'true'
})

const FEATURE_FLAGS: FeatureFlags = {
  NEW_UI: process.env.NEW_UI === 'true',
  // Add more feature flags here as needed
}

export const isFeatureEnabled = (featureFlag: keyof FeatureFlags): boolean => {
  const result = FEATURE_FLAGS[featureFlag] || false
  console.debug(`Feature flag ${featureFlag}:`, result)
  return result
}

export const getFeatureFlags = (): FeatureFlags => {
  return FEATURE_FLAGS
}

// For debugging - log active feature flags in development
console.debug('All feature flags:', FEATURE_FLAGS)